<template>
  <div :class="['info-card', addBtn ? 'add-btn' : '']">
    <header v-if="!addBtn">
      <div class="header-text">
        <h4>
          <slot name="header"></slot>
        </h4>
        <h6 class="sub">
          <slot name="sub"></slot>
        </h6>
      </div>
      <div v-if="status">
        <div
        :class="['status', color]"></div>
      </div>
    </header>
    <p>
      <slot></slot>
    </p>
    <footer v-if="!addBtn">
      <div class="left-control">
        <slot name="left-control"></slot>
      </div>
      <div class="right-control">
        <slot name="right-control"></slot>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    addBtn: {
      default: false
    },
    status: {
      default: false
    },
    color: {
      default: "black"
    }
  }
}
</script>

<style lang="scss" scoped>
.info-card {
  width: 100%;
  max-width: 26rem;
  height: 200px;
  margin: 20px;
  background-color: $white;
  padding: 20px 20px;
  box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
  display: grid;
  grid-template-rows: 1fr 1fr auto;
  grid-template-columns: 1fr;
  grid-template-areas: "head" "body" "foot";

  header {
    grid-area: head;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    .header-text .sub {
      @extend %audi;
    }
    .status {
      border-radius: 50%;
      width: 20px;
      height: 20px;
      // background-color: $black;
    }
  }

  p {
    grid-area: body;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0;
  }

  footer {
    grid-area: foot;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-top: 30px;
  }
  footer > .right-control > * {
    margin-left: 15px;
  }

  &.add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 10rem;

    p {
      @extend %audi;
      font-size: 50px;
      color: $bg_1;
    }
  }
}
.low {
  background-color: gold;
}
.medium {
  background-color: darkorange;
}
.high {
  background-color: red;
}
</style>
